module.exports = __webpack_public_path__ + "img/banner2026.e64106e.png";


//////////////////
// WEBPACK FOOTER
// ./static/cyber/banner2026.png
// module id = K9hT
// module chunks = 1